<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(1 1)"><path d="M773,344a9,9,0,1,1-9-9,9,9,0,0,1,9,9Zm0,0" transform="translate(-755 -335)" fill="#f0f0f0"/><path d="M1036.9,356.178a9,9,0,0,0-5.87-8.44v16.88a9,9,0,0,0,5.87-8.44Zm0,0" transform="translate(-1018.905 -347.178)" fill="#d80027"/><path d="M755,356.178a9,9,0,0,0,5.87,8.44v-16.88a9,9,0,0,0-5.87,8.44Zm0,0" transform="translate(-755 -347.178)" fill="#6da544"/><g fill="none" stroke="#e4e4e4" stroke-width="1"><circle cx="9" cy="9" r="9" stroke="none"/><circle cx="9" cy="9" r="9.5" fill="none"/></g></g></svg>
</template>

<script>
  export default {
    name: 'it-IT',
  };
</script>
